import { POColumns, ThongTinXacNhanCTModel, ThongTinXacNhanModel } from './../kd-dat-hang-model/kd-dat-hang.model';
import { ThongTinHangVeAddEditComponent } from './../../../mua-hang/ke-hoach-hang-ve/phieu-thong-tin-hang-ve-ke-hoach/phieu-thong-tin-hang-ve-ke-hoach.component';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import {Component,
		OnInit,
		ElementRef,
		ViewChildren,
		ViewChild,
		ChangeDetectionStrategy,
		ChangeDetectorRef,
		Inject
	}
from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { ReplaySubject,BehaviorSubject } from 'rxjs';
//Service
import { KDDatHangService } from '../kd-dat-hang-service/kd-dat-hang.service';
import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
//Model
import { KDDatHang, KDDatHangChiTiet } from '../kd-dat-hang-model/kd-dat-hang.model';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import moment from 'moment';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';

@Component({
	selector: 'm-thong-tin-xac-nhan',
	templateUrl: './thong-tin-xac-nhan.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[DatePipe]
})

export class ThongTinXacNhanComponent implements OnInit {
	/*Config Form */
	CONFIG: CommonConFig;
	/* Các trường focus cho các tag trong form */
	@ViewChildren('focus') focus ;
	@ViewChildren('focusNCC') focusNCC;
	@ViewChildren('focusQC') focusQC;
	@ViewChildren('focusNVNH') focusNVNH;
	@ViewChildren('focusKho') focusKho;
	@ViewChildren('focusGhiChu') focusGhiChu;

	/* Trigger menu hiển thị cột cho danh sách */
	@ViewChild('trigger', {static: true}) _trigger: MatMenuTrigger;

	/* Comment columns mat-table
		Các trường columns cho bảng:
		- displayedColumns: display ra form
		- availableColumns: các cột sẽ được add vào display.
		- extendsColumns: các cột mở rộng thêm cho display khi QC kiểm tra
	*/
	displayedColumns = [];
	availableColumns = POColumns.columns;
	extendsColumn = [];

	/* End comment columns mat-table -------------------------------------*/

	/* Mat select search cho nhà cung cấp */
	listListNCC : any[] = [];
	selectListNCC : string = '';
	filteredListNCC: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListNCCFilterCtrl: string = '';
	haveElementListNCC: boolean = false;
	/* ------------------------------------------------------------------ */

	/* Mat select search cho hop dong */
	listHD : any[] = [];
	selectHD : string = '';
	filteredHD: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	HDFilterCtrl: string = '';
	haveElementHD: boolean = false;
	/* ------------------------------------------------------------------ */

	/* Giá trị đầu tiên cho dropdown quyết định nhập hàng - Form QC kiểm tra*/
	selectQuyetDinhLoHang = '0';
	/* ------------------------------------------------------------------ */

	/* Selection */
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<KDDatHangChiTiet>(true, []);
	/* ------------------------------------------------------------------ */

	/* Loading.... */
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */

	/* Extend field:  */
	previousIndex: number; 			// Lưu lại vị trí trước đó khi swap các cột trên lưới
	fixedPoint = 2;                 // Số chữ số phần thập phân cho kiểu dữ liệu số.
	isChange: boolean = false;		// Trường kiểm tra dialog có cập nhập - thay đổi dữ liệu hay không
	isZoomSize: boolean = false;    // Trường đánh dấu có đang ở trạng thái zoom size hay không
	saveAddedTTHV: number[] = []	// Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	viewLoading: boolean = false;   // Loading khi mở dialog
	canEdit: boolean = false;		// Dialog có thể chỉnh sửa không?
	/* ------------------------------------------------------------------ */

	/* Các Sub form trên dialog:  */
	ThongTinXacNhanForm: FormGroup;
	ThongTinXacNhanCtsForm: FormGroup;
	/* ------------------------------------------------------------------ */

	/* Item dữ liệu từ của phiếu đề nghị khi mở dialog:  */
	ThongTinXacNhanItem: ThongTinXacNhanModel;

	/* Danh sách chi tiết hàng hóa của phiếu đề nghị:  */
	listChiTietHangVe: KDDatHangChiTiet[] = [];

	/* Danh sách tạm chi tiết hàng hóa của phiếu đề nghị dùng để cập nhập trên lưới  */
	tmpChiTietKDDatHang: any[] = [];
	historiesDetailPO: any[] = [];

	/* Danh sách chi tiết hàng hóa của phiếu đề nghị lúc đầu dùng để so sánh -> cập nhập trạng thái phiếu */
	compareChiTietHangVe: KDDatHangChiTiet[] = [];

	TinhTrang = [
		{
			Code: 'DDH_PHIEUMOI',
			Name: 'Phiếu mới'
		},
		{
			Code: 'DDH_CHOTPDUYET',
			Name: 'Chờ TP duyệt'
		},
		{
			Code: 'DDH_TPKHONGDUYET',
			Name: 'TP không duyệt'
		},
		{
			Code: 'DDH_CHOGDDUYET',
			Name: 'Chờ GĐ duyệt'
		},
		{
			Code: 'DDH_GDKHONGDUYET',
			Name: 'GĐ không duyệt'
		},
		{
			Code: 'DDH_HOANTAT',
			Name: 'Hoàn tất'
		},
		{
			Code: 'DDH_DAHUY',
			Name: 'Đã hủy'
		},
	];

	CHUCDANH_TRUONGPHONG = 1;
	CHUCDANH_GIAMDOC = 2;
	xac_nhan: boolean = false;
	chi_tiet: boolean = false;

	vung_1: boolean = true;
	minDate =  new Date();

	// .. Khai báo biến cho select multi
	selected : any[] = [];
	DXYCGH_KDDPM = "KDDH_DXYCGH_KDDPM";
	DXYCGH_KHDPM = "KDDH_DXYCGH_KHDPM";
	DONGYYCGH    = "KDDH_DONGYYCGH";
	// .................................

	// .. Khai báo biến loading reload form
	loadingData = new BehaviorSubject<boolean>(false);
	// .................................

	constructor(
		public dialogRef: MatDialogRef<ThongTinXacNhanComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private KDDatHangService: KDDatHangService,
		private DungChungService: DungChungService,
		public dialog: MatDialog,
		private ThongTinXacNhanFormFB: FormBuilder,
		private ThongTinXacNhanFormCtsFB: FormBuilder,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private el: ElementRef
	) { }

	/** LOAD DATA */
	async ngOnInit() {
		
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();

		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.keyCode == this.CONFIG.BUTTON_FORM.BACK.KeyCombine.keycode){
				this.back();
			}
			
			if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.DONGYYCGH.KeyCombine.keycode && this.xac_nhan) {
				this.setThongTinXacNhan(false);
			}
		});
		this.xac_nhan = this.data.xac_nhan? this.data.xac_nhan : false;
		this.chi_tiet = this.data.chi_tiet? this.data.chi_tiet : false;

		if(this.chi_tiet) this.vung_1 = false;

		/*Get data from list when open dialog */
		this.ThongTinXacNhanItem = new ThongTinXacNhanModel();
		this.ThongTinXacNhanItem.clear();
		
		/*Load all dropdown and create form */
		this.createForm();

		let __idDH = this.data.data.IdDH;
		let __idCT = this.data.data.IdCt;
		let res = await this.KDDatHangService.getThongTinXacNhan(__idDH, __idCT).toPromise();
		if(res && res.status === 1){
			this.ThongTinXacNhanItem = res.data;
			this.createForm();
		}else{
			this.layoutUtilsService.showErorr("Lỗi lấy thông tin chi tiết phiếu");
		}
		/*Handel escape event in dialog*/
		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key == "Escape") {
				this.back();
			}
		});
		if(this.xac_nhan){
			this.extendsColumn.forEach(element => {
				this.availableColumns.splice(this.availableColumns.length, 0 ,element);
			});
			this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		}
		/*Show column */
		this.showColumnsInTable();
		this.applySelectedColumns();
		this.changeDetect.detectChanges();
	}

	ngAfterViewInit() {
		/*Focus on first input field*/
		//this.focus.first.nativeElement.focus();
		this.changeDetect.detectChanges();
    }

	/*Create Form with appropriate sub forms */
	createForm(){

		/*Get name of người lập phiếu */
		var tenNguoiLap = '';
		this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });
		var item = this.ThongTinXacNhanItem;
		/*Group các Form */
		this.ThongTinXacNhanForm = this.ThongTinXacNhanFormFB.group({
			NGUOIXACNHAN : [item.TenNguoiXacNhan? item.TenNguoiXacNhan : tenNguoiLap, Validators.required],
			NGAYXACNHAN : [item.NgayXacNhan? item.NgayXacNhan : new Date(), Validators.required],
			MAHH : [item.MaHH, Validators.required],
			TENHH : [item.TenHH, Validators.required]
		});
		if(this.vung_1){
			this.ThongTinXacNhanCtsForm = this.ThongTinXacNhanFormCtsFB.group({
				NGAYGIAO : [new Date(), Validators.required],
				SLGIAO: ['0,00', Validators.compose([Validators.required, Validators.min(0.01) ,Validators.pattern(this.CONFIG.REGEX_FORMAT_NUMBER)])]
			})
		}

		this.ThongTinXacNhanForm.disable();
		this.tmpChiTietKDDatHang = item.CTs;
		this.tmpChiTietKDDatHang.forEach(x => x.Index = (this.tmpChiTietKDDatHang.indexOf(x) + 1));
		this.tmpChiTietKDDatHang = [...this.tmpChiTietKDDatHang];
		this.historiesDetailPO = [...item.Histories];
		this.historiesDetailPO = [...this.historiesDetailPO];
	}

	/*Lấy tiêu đề cho dialog với các TH thêm - sửa - QC kiểm tra*/
	getTitle(): string {
		return `XÁC NHẬN KẾ HOẠCH GIAO HÀNG `;
	}

	/*Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng*/
    showColumnsInTable(){
		for(let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].isShow == false){
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string){
		for( let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for(let i = 0; i < this.availableColumns.length; i++){
			this.selectedColumns.toggle(this.availableColumns[i]);
			for( let j = 0; j < _selectedColumns.length; j++){
				if( this.availableColumns[i].name == _selectedColumns[j].name){
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
	/*---------------------------------------------------------------------------------------- */

	/*Hàm hỗ trợ format các dạng số trên form*/
	formatNumber(item: string){
		if(item == '' || item == null || item == undefined)	return '0.00';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-'+ this.fixedPoint).toFixed(this.fixedPoint);
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0,value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1),(this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if(value == '-1') return '';
		if (value == null || value == undefined || value == '') value = '0';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	/*------------------------------------------------------------- */

	/*Hàm hỗ trợ format các dạng ngày trên form*/
	getFormatDate(v: string = '') {
        if (v != '') {
            return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
        }
        return '';
	}
	f_convertDate(p_Val: any) {
		if(p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	/*------------------------------------------------------------- */

	back(){
		this.dialogRef.close({
			isChange: this.isChange,
		});
	}

	//#region Kiểm tra định dạng số lượng 
	keyUpInputNumber(event){
		FunctionPublic.preventAlpha(event);
	}

	changeInputKhoiLuong(event, columnName){
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) { 
			event.preventDefault(); 
		}
		else{
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) 
			{ return; } 

			let data = FunctionPublic.slListChanged(event);
			if(data){
				this.ThongTinXacNhanCtsForm.controls[columnName].setValue(data);
				this.changeDetect.detectChanges();
			}
		}
	}
	//#endregion Kiểm tra định dạng số lượng

	//#region Hàm kiểm tra trường hợp lỗi số lượng
	showErrorInputSL(){
		let message = "";
		let controls = this.ThongTinXacNhanCtsForm.controls;
		if(controls['SLGIAO'].value.length == 0) return 'SL giao là bắt buộc';
		if(this.formatComparenumber(controls['SLGIAO'].value) == 0) return 'SL giao phải lớn hơn 0,00';
		if(controls['SLGIAO'].hasError('maxlength') 
			|| (controls['SLGIAO'].value.length > 22 
				&& (controls['SLGIAO'].value.indexOf(',') == 0 || controls['SLGIAO'].value.indexOf(',') > 21))) 
			return 'Tối đa 18 chữ số với 2 chữ số thập phân';
		return message;
	}
	formatComparenumber(number: string){
		return +number.replace(/\./g, "").replace(/,/g, ".");;
	}

	addHang(){
		// Check form
		const controls = this.ThongTinXacNhanCtsForm.controls;
		/** check form */
		if (this.ThongTinXacNhanCtsForm.invalid) {
			const invalidElements = this.el.nativeElement.querySelectorAll('.ng-invalid');
			//let indexList = [];
			if (invalidElements.length > 0) {
				for(let i = 0; i < invalidElements.length; i++){
					if(invalidElements[i].nodeName == 'INPUT' || invalidElements[i].nodeName == 'MAT-SELECT'){
						const elementControl = this.ThongTinXacNhanCtsForm.get(invalidElements[i].attributes.getNamedItem("formcontrolname").value);
						if(elementControl){
							setTimeout(() => invalidElements[i].focus(), 100);
							break;
						}
					}
				}
			}


			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			return;
		}
		let tmp = new ThongTinXacNhanCTModel();
		tmp.IdDH = this.data.data.IdDH;
		tmp.IdCt = this.data.data.IdCt;
		tmp.SLGiao = this.formatComparenumber(this.ThongTinXacNhanCtsForm.controls['SLGIAO'].value.toString());
		tmp.NgayGiao = moment(this.ThongTinXacNhanCtsForm.controls['NGAYGIAO'].value).format("YYYY-MM-DD").toString();
		

		let tongDaGiao = this.tmpChiTietKDDatHang.length > 0 ? this.tmpChiTietKDDatHang.map(x => x.SLGiao).reduce((a,b) => a + b) : 0;
		if((tongDaGiao + tmp.SLGiao) > this.formatComparenumber(this.ThongTinXacNhanForm.controls['SLDAT'].value.toString())){
			this.layoutUtilsService.showErorr("Tổng số lượng hàng giao vượt quá số lượng hàng đặt");
			return;
		}
		
		let index = this.tmpChiTietKDDatHang.findIndex(x => moment( x.NgayGiao).format("YYYY-MM-DD").toString() == tmp.NgayGiao);
		if(index > -1) this.tmpChiTietKDDatHang[index].SLGiao += tmp.SLGiao;
		else this.tmpChiTietKDDatHang.push(tmp);

		// Kiem tra da ton tai tu truoc chua
		let it = this.tmpChiTietKDDatHang;
		this.tmpChiTietKDDatHang = [];
		this.tmpChiTietKDDatHang = [...it];

		// Reset form
		this.ThongTinXacNhanCtsForm.reset();

		// Sinh lại form
		this.ThongTinXacNhanCtsForm.controls['SLGIAO'].setValue('0,00');
		this.ThongTinXacNhanCtsForm.controls['NGAYGIAO'].setValue(new Date());
		this.changeDetect.detectChanges();
	}

	changeValueOfForm(controlName: string, event: any){
		if(this.ValidateChangeNumberForm(event)){
			let tmpValue = this.ThongTinXacNhanCtsForm.controls[controlName].value.replace(/,/g, "");
			if(!this.ThongTinXacNhanCtsForm.controls[controlName].invalid){
				this.ThongTinXacNhanCtsForm.controls[controlName].setValue(
					this.f_currency(this.formatNumber(tmpValue))
				);
			}
			if(tmpValue.indexOf('.') == 0 && tmpValue.length == 1){
				tmpValue = 0;
			}
			this.ThongTinXacNhanCtsForm.controls[controlName].setValue(
				this.f_currency(this.formatNumber(tmpValue))
			);
		}
		else{
			this.ThongTinXacNhanCtsForm.controls[controlName].setValue(''+event.target.value);
		}
	}
	ValidateChangeNumberForm(event: any, isEvent:boolean = true) {
		var count = 0;
		if(isEvent){
			for(let i = 0; i < event.target.value.length; i++){
				if(event.target.value[i] == ','){
					count += 1;
				}
			}
		}
		else{
			event = "" + event
			for(let i = 0; i < event.length; i++){
				if(event[i] == ','){
					count += 1;
				}
			}
		}
		;
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = isEvent ? event.target.value.match(regex) : String(event).match(regex);
		if (found != null) {
			const message = 'Số lượng không gồm chữ hoặc kí tự đặc biệt';
			return false;;
		}
		if (count >= 2) {
			const message = 'Số lượng không thể có nhiều hơn 2 dấu .';
			return false;;
		}

		return true;
	}

	/*Xóa dữ liệu hàng hóa trong bảng*/
	deleteItem(item: any){
		let index = this.tmpChiTietKDDatHang.indexOf(item, 0);
		if (index > -1) {
			this.tmpChiTietKDDatHang.splice(index, 1);
		}
		this.tmpChiTietKDDatHang = [...this.tmpChiTietKDDatHang];
		this.changeDetect.detectChanges();
	}

	checkButton2(){
		let sum = 0;
		this.tmpChiTietKDDatHang.forEach(x => {
			sum += x.SLGiao;
		})
		if(this.tmpChiTietKDDatHang.length == 0 || (sum > this.ThongTinXacNhanItem.SLDat || sum < this.ThongTinXacNhanItem.SLDat)) return true;
		return false;
	}

	setThongTinXacNhan(status: boolean){
		
		const _sophieu: string = "";
		const data = this.createItem(status);
		const MESSAGE_ERROR = "Vui lòng nhập ngày yêu cầu giao hàng mới";

		// .. Kiểm tra dữ liệu trước khi xác nhận
		if (status){
			var errorIndex = data.filter(x => !x.NgayYCGiaoMoi);
			if (errorIndex.length > 0){
				this.layoutUtilsService.showErorr(MESSAGE_ERROR);
				return;
			}
		}
		// ......................................
		const dialogRef = this.layoutUtilsService.POP02(_sophieu);
		dialogRef.afterClosed().subscribe(res => {
			if (!res) return;
			this.KDDatHangService.xacNhanThongTinInsert(data).subscribe(res => this.runAfterAddOrUpdate(res, status))
		});

		//Update ngày 03/12/2020
		//Chỉ còn một nút đồng ý
	}

	runAfterAddOrUpdate(res, status){
		if(res && res.status === 1){
			this.isChange = true;
			var MESSAGE_INFOR = (!status ? "Xác nhận" : "Đề xuất yêu cầu giao hàng") + " cho các đơn hàng đã chọn thành công!";
			this.layoutUtilsService.showInfo(MESSAGE_INFOR);
			this.selected = [];
			this.reloadForm();
		}else{
			this.layoutUtilsService.showErorr(res.error.message);
		}
	}

	createItem(status){
		var result = [];
		var data = this.tmpChiTietKDDatHang.filter(x => this.selected.includes(x.Id));
		if (data.length == 0) return null;
		data.forEach(item => {
			var allChilds = this.childsEqualParent(item.Id);
			if (allChilds.length > 0){
				allChilds.forEach(child => {
					var obj = new ThongTinXacNhanCTModel();
					obj.clear();
					obj.Id 				= child.Id;
					obj.IdCt 			= child.IdCt;
					obj.IdDH 			= child.IdDH;
					obj.SLGiao 			= Number(child.SLGiao);
					obj.NgayGiao 		= null;
					obj.NgayYCGiao 		= null;
					obj.NgayYCGiaoMoi 	= (!status || !child.NgayYCGiaoMoi) ? null : moment(child.NgayYCGiaoMoi).format("YYYY-MM-DD");
					obj.TrangThai 		= !status ? this.DONGYYCGH : (child.TrangThai == this.DXYCGH_KHDPM ? this.DXYCGH_KDDPM : this.DXYCGH_KHDPM);
					obj.IdParent 		= item.Id;
					result.push(obj);
				})
			}else{
				var obj = new ThongTinXacNhanCTModel();
				obj.clear();
				obj.Id 				= item.Id;
				obj.IdCt 			= item.IdCt;
				obj.IdDH 			= item.IdDH;
				obj.SLGiao 			= Number(item.SLGiao);
				obj.NgayGiao 		= item.NgayGiao; 
				obj.NgayYCGiao 		= moment(item.NgayYCGiao).format("YYYY-MM-DD");
				obj.NgayYCGiaoMoi 	= (!status || !item.NgayYCGiaoMoi) ? null : moment(item.NgayYCGiaoMoi).format("YYYY-MM-DD");
				obj.TrangThai 		= !status ? this.DONGYYCGH : (item.TrangThai == this.DXYCGH_KHDPM ? this.DXYCGH_KDDPM : this.DXYCGH_KHDPM);
				result.push(obj);
			}
		});
		return result;
	}

	keyUpInputNumberVND(event){
		FunctionPublic.preventAlpha(event);
	}

	changeInputNumberVND(event, columnName, min: number = 0, formGroup){
		let controls = formGroup.controls;
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) { 
			event.preventDefault(); 
		}
		else{
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) 
			{ return; } 

			let data = FunctionPublic.slListChangedV2(event);
			if(data){
				if(this.formatComparenumber(data) < min && event.data && event.data == '0') data = this.f_currency_VND(this.formatNumber(min.toString()));
				controls[columnName].setValue(data);
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;
				
			}else{
				controls[columnName].setValue(this.f_currency_VND(this.formatNumber(min.toString())));
			}
		}
	}

	f_currency_VND(value: string): any {
		if (value == null || value == undefined) return '0,00';
		return new Intl.NumberFormat('de-DE',{ style: 'decimal', currency: 'VND', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
	}

	changeInputOfFormVND(controlName: string, event: any, min: number = 0, formGroup){
		let controls = formGroup.controls;
		if(this.ValidateChangeNumberForm(event)){
			let tmpValue = controls[controlName].value.replace(/\./g, "").replace(/,/g, ".");
			
			if(Number(tmpValue) < min) tmpValue = min;

			if(!controls[controlName].invalid){
				controls[controlName].setValue(
					this.f_currency_VND(this.formatNumber(tmpValue))
				);
			}
			if(tmpValue.indexOf(',') == 0 && tmpValue.length == 1){
				tmpValue = min;
			}
			controls[controlName].setValue(
				this.f_currency_VND(this.formatNumber(tmpValue))
			);
		}
		else{
			controls[controlName].setValue(this.f_currency_VND(this.formatNumber(min.toString())));
			//console.log(controls[controlName].value);
		}
	}

	checkDateNull(event){
		if(!event.target.value){
			this.ThongTinXacNhanCtsForm.controls['NGAYGIAO'].setValue(new Date());
			this.changeDetect.detectChanges();
		}
	}

	// .. Xử lý check chọn all
	changeSelectedMulti(event){
		if (event.checked)
			this.selected = this.tmpChiTietKDDatHang.filter(x => x.TrangThai != this.DONGYYCGH && x.IsDXYCGHM && !x.IdParent).map(x => x.Id);
		else
			this.selected = [];
		this.changeDetect.detectChanges();
	}
	// .......................
	// .. Kiểm tra check full
	isCheckFull(){
		var data = this.tmpChiTietKDDatHang.filter(x => x.TrangThai != this.DONGYYCGH && x.IsDXYCGHM && !x.IdParent);
		return this.selected.length > 0 && data.length == this.selected.length;
	}
	// .......................
	// .. Kiểm tra đã check nhưng chưa phải tất cả
	isCheckNonFull(){
		return this.selected.length > 0 && this.tmpChiTietKDDatHang.filter(x => x.TrangThai != this.DONGYYCGH && x.IsDXYCGHM && !x.IdParent).length > this.selected.length;
	}
	// .......................
	// .. Kiểm tra xem còn hàng hóa nào chưa xác nhận đồng ý
	showCheckboxAll(){
		return this.tmpChiTietKDDatHang.filter(x => x.TrangThai != this.DONGYYCGH && x.IsDXYCGHM && !x.IdParent).length == 0;
	}
	// .......................
	// .. Xử lý check chọn theo dòng
	changeSelected(event, item){
		if (event.checked)
			this.selected.push(item.Id);
		else
			this.selected = this.selected.filter(x => x != item.Id);
		this.changeDetect.detectChanges();
	}
	// ...................
	// .. Kiểm tra checkbox dòng đã check chưa
	isChecked(item){
		return this.selected.includes(item.Id);
	}
	// ...................
	// .. Reload Dialog form
	async reloadForm(){
		var idPO = this.data.data.IdDH;
		var idCT = this.data.data.IdCt;
		var res = await this.KDDatHangService.getThongTinXacNhan(idPO, idCT).toPromise();
		if(!res || res.status === 0){
			this.layoutUtilsService.showErorr("Lỗi lấy thông tin thông tin xác nhận");
			return;
		}
		this.ThongTinXacNhanItem = res.data;
		this.tmpChiTietKDDatHang = [];
		this.createForm();
		this.changeDetect.detectChanges();
	}
	// .....................
	// .. Tách hàng 
	detached(item, index){
		var allChilds = this.childsEqualParent(item.Id);
		var detachedRow = {...item};
		detachedRow["Id"] = 0;
		detachedRow["IdParent"] = item.Id;
		detachedRow["SLGiao"] = this.balanceDetached(item.SLGiao, allChilds.length + 1);
		var position = index + allChilds.length + 1;
		this.tmpChiTietKDDatHang.splice(position, 0, detachedRow);
		this.tmpChiTietKDDatHang = [...this.tmpChiTietKDDatHang];
		this.updateEqualIdParent(item.Id, detachedRow["SLGiao"]);
		this.changeDetect.detectChanges();
	}
	unDetached(item, index){
		this.tmpChiTietKDDatHang.splice(index, 1);
		this.tmpChiTietKDDatHang = [...this.tmpChiTietKDDatHang];
		var allChilds = this.childsEqualParent(item.IdParent);
		var parent = this.parentInfor(item.IdParent);
		this.updateEqualIdParent(item.IdParent, this.balanceDetached(parent["SLGiao"], allChilds.length));
		this.changeDetect.detectChanges();
	}
	// ........................................
	// .. Lấy số lượng dòng con cùng idparent
	childsEqualParent(id){
		return this.tmpChiTietKDDatHang.filter(x => x.IdParent == id);
	}
	parentInfor(id){
		return this.tmpChiTietKDDatHang.find(x => x.Id == id);
	}
	// ........................................
	// .. Balance số lượng giao
	balanceDetached(numAll, numChilds){
		return numChilds == 0? numAll : (numAll/numChilds).toFixed(2);;
	}
	// ........................................
	// .. Update dòng cùng idparent
	updateEqualIdParent(id, balance){
		this.tmpChiTietKDDatHang.forEach((x, index) => {
			if (x.IdParent && x.IdParent == id)
				this.tmpChiTietKDDatHang[index].SLGiao = balance;
		});
		this.tmpChiTietKDDatHang = [...this.tmpChiTietKDDatHang];
	}
	// ........................................
	// .. Copy hàm xử lý nhập số
	changeNumber(event, min: number = 0) {
		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = event.target.value.replace(/\./g, "").replace(/,/g, ".");
			if (Number(tmpValue) < min) tmpValue = min;
			if (event.target.value) 
				event.target.value = this.f_currency_VND(this.formatNumber(tmpValue));
			if (('' + tmpValue).indexOf(',') == 0 && tmpValue.length == 1) 
				tmpValue = min;
			event.target.value = this.f_currency_VND(this.formatNumber(tmpValue));
		}
		else {
			event.target.value = this.f_currency_VND(this.formatNumber(min.toString()));
		}
	}
	checkSLDetail(item, event) {
		var max = item.SLGiao;
		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = event.target.value.replace(/\./g, "").replace(/,/g, ".");
			//#region  TÍNH MAX
			if (this.tmpChiTietKDDatHang.length > 0) {
				var m = this.ThongTinXacNhanItem.SLDat;
				var listCheck = [];
				this.tmpChiTietKDDatHang.forEach(x => {
					if (x.TrangThai == this.DONGYYCGH)
						listCheck.push(x);
					if (x.TrangThai != this.DONGYYCGH){
						if ((!x.IdParent && this.childsEqualParent(x.Id).length == 0) || (x.IdParent && x != item))
							listCheck.push(x);
					}
				});
				if (listCheck.length > 0)
					listCheck.forEach(x => m -= (+x.SLGiao));
			}
			max = Math.max(m, max);
			//#endregion
			if (Number(tmpValue) >= max) tmpValue = max;
			if (event.target.value)
				event.target.value = this.f_currency_VND(this.formatNumber(tmpValue));
			if (('' + tmpValue).indexOf(',') == 0 && tmpValue.length == 1) 
				tmpValue = max;
			event.target.value = this.f_currency_VND(this.formatNumber(tmpValue));
			item.SLGiao = tmpValue;
		}
		else {
			event.target.value = this.f_currency_VND(this.formatNumber(max.toString()));
			item.SLGiao = max;
		}
	}
	// ........................................
	// .. Tính stt dòng
	positionItem(item, array){
		return array.filter(x => !x.IdParent).indexOf(item) + 1;
	}
	// ........................................
}
